import type { ReactNode } from "react";
import {
  cn,
  layout,
  spacing,
  responsive
} from "@/utilities/tailwind-utils";

interface StatsGridProps {
  children: ReactNode;
  columns?: 2 | 3 | 4;
  className?: string;
}

export function StatsGrid({ children, columns = 4, className }: StatsGridProps) {
  const colsClass =
    columns === 2
      ? responsive.gridCols1MdGridCols2
      : columns === 3
        ? "grid-cols-1 md:grid-cols-3"
        : responsive.gridCols1MdGridCols2LgGridCols4;

  return (
    <div
      className={cn(
        layout.grid,
        colsClass,
        spacing.gap4,
        spacing.mb6,
        className
      )}
    >
      {children}
    </div>
  );
}
